export default "__VITE_ASSET__CxnOSOOV__"